import {
  FETCH_STORE_RETURN_OVERVIEW,
  RESET_STORE_RETURN_OVERVIEW,
} from "../../constants/action.constants";

//Storage for data.
const initialState = {
  list: [],
  others: {
    total: 0,
    offset: 0,
    limit: 10,
  },
};

//Controller for the storage.
const storeReturnOverviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STORE_RETURN_OVERVIEW:
      return { list: action.payload, others: action.others };
    case RESET_STORE_RETURN_OVERVIEW:
      return initialState;
    default:
      return state;
  }
};

export default storeReturnOverviewReducer;
